import React from 'react';
import {useInferableTranslation} from '@di-shared/features/common/useInferableTranslation';
import ImageSelector from '@di-shared/features/common/ImageSelector';

interface HomeMileageBeforeAgreementKrProps {
  onClick(): void;
}

function HomeMileageBeforeAgreementKr({onClick}: HomeMileageBeforeAgreementKrProps) {
  const {t} = useInferableTranslation();
  return (
    <section className="section section_eco_mileage">
      <div className="section_container">
        <div className="section_container_header">
          <div className="container_header_title">
            <h3 className="label_medium_b">{t('T10122')}</h3>
            <strong
              className="title_xxsmall"
              style={{whiteSpace: 'pre-wrap'}}
            >
              {t('T10132')}
            </strong>
          </div>
        </div>
        <div className="eco_state_before">
          <ImageSelector
            alt={'eco_mileage'}
            kiaLightSrc={() => import('@di-shared/assets/img/home/eco_mileage.png')}
            kiaDarkSrc={() => import('@di-shared/assets/img/home/eco_mileage.png')}
            hyundaiLightSrc={() => import('@di-shared/assets/img/home/hyundai/eco_mileage.png')}
            hyundaiDarkSrc={() => import('@di-shared/assets/img/home/hyundai/eco_mileage.png')}
            genesisLightSrc={() => import('@di-shared/assets/img/home/genesis/eco_mileage.png')}
            genesisDarkSrc={() => import('@di-shared/assets/img/home/genesis/eco_mileage.png')}
          />
        </div>

        <button
          type="button"
          className="btn btn_large btn_filled btn_full"
          onClick={onClick}
        >
          {t('T10131')}
        </button>
      </div>
    </section>
  );
}

export default HomeMileageBeforeAgreementKr;
